import React, { useState, useEffect } from "react"
import Plus from "../images/components/plus.svg"
import Close from "../images/components/close.svg"

const Panel = ({ toggle = false, children }) => {
  const [open, setOpen] = useState(false)
  const [transition, setTransition] = useState(false)
  const [prevToggle, setPrevToggle] = useState(toggle)

  useEffect(() => {
    if (toggle === prevToggle) return

    setOpen(!open)
    setTransition(true)
    setPrevToggle(toggle)
  }, [toggle])

  const handleToggle = () => {
    setOpen(!open)
    setTransition(true)
  }

  const handleTransition = () => {
    setTransition(false)
  }

  return (
    <div
      className={`panel ${open ? "panel--open" : ""} ${
        transition ? "panel--transition" : ""
      }`}
      onTransitionEnd={handleTransition}
    >
      <div className="panel__background">{children}</div>
      <div onClick={handleToggle} className="panel__button">
        {open ? <Close /> : <Plus />}
      </div>
    </div>
  )
}

export default Panel
